import { useParams, Link } from "react-router-dom";
import { POLICIES, POLICY_UPDATED } from "@/data/content";
import { Overline } from "@/components/common/ui";

export default function Policy() {
  const { type } = useParams();
  const policy = POLICIES[type] || POLICIES.shipping;

  return (
    <div data-testid="policy-page" className="bg-[#FFFCFA]">
      <header className="border-b border-[#F2E8E6] bg-white py-20 md:py-28">
        <div className="mx-auto max-w-3xl px-6">
          <Overline>Legal</Overline>
          <h1 className="mt-4 font-display text-5xl font-light text-[#2C2B2C] sm:text-6xl">{policy.title}</h1>
          <p className="mt-5 max-w-xl text-base font-light text-[#8A7F86]">{policy.intro}</p>
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-[#8A7F86]">Last updated · {POLICY_UPDATED}</p>
        </div>
      </header>

      <div className="mx-auto max-w-3xl px-6 py-16">
        <div className="space-y-10">
          {policy.sections.map(([h, p], i) => (
            <div key={i} className="border-b border-[#F2E8E6] pb-8">
              <h2 className="font-display text-2xl text-[#2C2B2C]">{h}</h2>
              <p className="mt-3 text-base font-light leading-relaxed text-[#8A7F86]">{p}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap gap-3">
          {Object.keys(POLICIES).map((k) => (
            <Link key={k} to={`/policies/${k}`} data-testid={`policy-link-${k}`}
              className={`px-5 py-2.5 text-xs uppercase tracking-[0.15em] transition-colors ${k === type ? "bg-[#232222] text-[#FFFCFA]" : "rounded-[2rem] border border-[#F2E8E6] text-[#8A7F86] hover:bg-white"}`}>
              {POLICIES[k].title}
            </Link>
          ))}
        </div>
        <p className="mt-10 text-sm text-[#8A7F86]">Questions? <Link to="/contact" className="text-[#2C2B2C] underline underline-offset-4">Contact our team</Link>.</p>
      </div>
    </div>
  );
}
